import { DataTypeColumn } from '../../commonColumnHelpers'

export const DOOR_CRM_REPORT_COLUMNS = {
  door_taglist: {
    header: 'Door Tags',
    group: 'Door Attributes',
    tooltipName: 'crm_door_tags',
  },
  door_distributors: {
    header: 'Door Known Distributors',
    group: 'Door Attributes',
    tooltipName: 'crm_door_distributors',
  },
  door_gpos: {
    header: 'Door Known GPOs',
    group: 'Door Attributes',
    tooltipName: 'crm_door_gpos',
  },
} satisfies Partial<Record<string, DataTypeColumn>>
